var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPieChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.261,
    height: 42.261,
    viewBox: "0 0 42.261 42.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_graph",
    "data-name": "vuesax/bulk/graph",
    transform: "translate(-300 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph",
    transform: "translate(300 188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph-2",
    "data-name": "graph",
    transform: "translate(3.526 3.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.306,8.715A12.3,12.3,0,0,0,8.171.58c-2.905-.845-4.913-.775-6.3.264C.194,2.094,0,4.348,0,5.951v4.385c0,4.332,1.972,6.533,5.846,6.533H10.9c1.585,0,3.856-.194,5.107-1.867C17.081,13.628,17.169,11.621,16.306,8.715Z",
    transform: "translate(18.326 0)",
    fill: "#fd403f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M29.772,15.163a2.409,2.409,0,0,0-1.814-.828h-6.3a5.621,5.621,0,0,1-5.617-5.617v-6.3A2.409,2.409,0,0,0,15.21.6,2.387,2.387,0,0,0,13.325.02,15.378,15.378,0,0,0,2.9,6.236,15.2,15.2,0,0,0,12.339,30.1a14.768,14.768,0,0,0,2.905.282,14.965,14.965,0,0,0,8.892-2.905,15.378,15.378,0,0,0,6.216-10.424A2.367,2.367,0,0,0,29.772,15.163Z",
    transform: "translate(0 4.839)",
    fill: "#fd403f",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H42.261V42.261H0Z",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.491766a51680445b4d04ecb6fec30a66.svg";
export { ForwardRef as ReactComponent };